import React, { Fragment, useState, useEffect } from "react";
import { Icon } from "antd";
import useMatspecSectionHeader from "./useMatspecSectionHeader";

const MatspecSectionHeader = React.memo(props => {
  const { showExpandAll, toggleAllCollapse, collapseAllOpen, singleAd } = props;
  const {
    matspecTableHeader,
    language,
    currentTabKey
  } = useMatspecSectionHeader(props);
  if (!matspecTableHeader) return null;
  return (
    <Fragment>
      <div className="section-container-table-header">
        {showExpandAll ? (
          <div className="section-container-table-header--special">
            <Icon
              type="double-right"
              onClick={toggleAllCollapse}
              rotate={collapseAllOpen ? 90 : 0}
            />
          </div>
        ) : null}
        {matspecTableHeader.map((item, index) => (
          <div key={index} className="section-container-table-header-item">
            {language && language[item] ? language[item] : item}
          </div>
        ))}
      </div>
    </Fragment>
  );
});

export default MatspecSectionHeader;



// WEBPACK FOOTER //
// ./src/components/MatspecSectionHeader/MatspecSectionHeader.js